module.exports = __webpack_public_path__ + "img/sm-web-small.cda452ae.png";